export const getDataCreativeFormat = (tag: string): string => {
  const matches = tag.match(
    new RegExp(`data-creative-format='` + "(.*)" + "' >")
  );
  const match = matches && matches.length && matches[1];
  return match ? "pxyz-" + match.toLowerCase() : "";
};
